import axios from "@/plugins/axios";

export default {
  getIncentiveFirings(params = {}) {
    let url = "firing/incentives";
    return axios.httpApi.get(url, {params});
  },
};
